import { metaMask } from 'wagmi/connectors';
import { extendConnector } from './utils.js';
export const createMetaMaskConnector = /*#__PURE__*/ (params) => extendConnector(metaMask(params), 'metaMaskSDK', 'MetaMask');
//# sourceMappingURL=metaMask.js.map